import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Container } from "reactstrap";
import MakeAsyncFunction from "react-redux-promise-listener";
import AdForm from "../../components/Ads/AdForm";
import { getAd, types } from "../../store/actions/ads";
import { promiseListener } from "../../store";



const AdPage = props => {
  const [id, setId] = useState(props.match.params.id);
  const [currentAd, setCurrentAd] = useState();
  useEffect(() => {
    setId(props.match.params.id);
    if (id && props.ads) {
      setCurrentAd(props.ads[id]);
    }
    if (id && (!props.ads || (currentAd && !currentAd.spec)) && props.loading !== id) {
      props.getAd(id);
    }
  })
  return (
    <Container fluid>
      <div className="d-flex align-items-center mb-4">
        <h4>{id ? 'ویرایش تبلیغ' : 'افزودن تبلیغ'}</h4>
      </div>
      <MakeAsyncFunction
        listener={promiseListener}
        resolve={types.SAVE_AD_SUCCESS}
        start={types.SAVE_AD_REQUEST}
        reject={types.SAVE_AD_FAILURE}
      >
        {onSubmit => (
          <React.Fragment>
            {id && currentAd &&
              <AdForm
                data={currentAd}
                onSubmit={onSubmit}
                goBack={() => props.history.push('/ads')}
                {...props}
              />
            }
            {!id &&
              <AdForm
                onSubmit={onSubmit}
                goBack={() => props.history.push('/ads')}
                history={props.history}
              />
            }
          </React.Fragment>
        )}
      </MakeAsyncFunction>
    </Container>
  )
}


export default connect(
  state => (
    {
      ads: state.ads.list,
      loading: state.loading.ad
    }
  ),
  dispatch => bindActionCreators({
    getAd
  }, dispatch)
)(AdPage)